// src/components/PdfPreviewModal/index.tsx
import React from 'react';
import { GridApi } from '@ag-grid-community/core';
import { ForgeIcon, ForgeDialog, ForgeToolbar, ForgeIconButton } from '@tylertech/forge-react';

import { CustomSortConfig, OrderConfig, LinkedAction } from 'common/visualizations/vif';
import { I18n } from 'common/i18n';
import { TableColumnFormat } from 'common/visualizations/views/agGridReact/types';
import { ColumnAggregation } from 'common/visualizations/dataProviders/types';
import { ExportData } from 'common/visualizations/views/agGridReact/types';
import { Dataset, ReportMetadata } from './types';
import { PreviewPane } from './PreviewPane';
import { ContextParams } from 'common/visualizations/views/agGridReact/helpers/processDiscoveryHelper';
import './PdfPreviewModal.scss';

interface PdfPreviewModalProps {
  dataset: Dataset;
  getExportData?: (selectedFiltered: boolean) => Promise<ExportData>;
  gridApi: GridApi | null;
  onClose: () => void;
  reportMetadata: ReportMetadata;
  nonStandardAggregations: ColumnAggregation[] | null;
  columnFormats: { [key: string]: TableColumnFormat };
  vifOrderConfig: OrderConfig[];
  showSubTotal: boolean;
  showTotal: boolean;
  columnSortConfig?: CustomSortConfig;
  processDiscoveryContext: ContextParams;
  linkedAction: LinkedAction;
}

export const PdfPreviewModal: React.FC<PdfPreviewModalProps> = ({
  dataset,
  getExportData,
  gridApi,
  onClose,
  reportMetadata,
  columnFormats,
  nonStandardAggregations,
  vifOrderConfig,
  showSubTotal,
  showTotal,
  columnSortConfig,
  processDiscoveryContext,
  linkedAction,
}) => {
  const dialogProps = { fullscreen: true };

  return (
    <ForgeDialog
      open={true}
      options={dialogProps}
      on-forge-dialog-close={onClose}
      aria-labelledby="pdf-preview-title"
    >
      <div className="pdf-preview-modal">
        <div className="preview-modal-header">
          <h2 id="pdf-preview-title">{I18n.t('common.pdf_preview.print_preview')}</h2>
          <ForgeIconButton slot="end" aria-label="Close Print Preview" onClick={onClose}>
            <ForgeIcon name="close"></ForgeIcon>
          </ForgeIconButton>
        </div>
        <div className="pdf-preview-body">
          {gridApi && getExportData && (
            <PreviewPane
              processDiscoveryContext={processDiscoveryContext}
              linkedAction={linkedAction}
              dataset={dataset}
              getExportData={getExportData}
              gridApi={gridApi}
              nonStandardAggregations={nonStandardAggregations}
              columnFormats={columnFormats}
              reportMetadata={reportMetadata}
              showSubTotal={showSubTotal}
              showTotal={showTotal}
              vifOrderConfig={vifOrderConfig}
              columnSortConfig={columnSortConfig}
            />
          )}
        </div>
      </div>
    </ForgeDialog>
  );
};
